import React from 'react'
import { Link } from 'react-router-dom'

export default function Pomegranate() {
  return <>
    <div className="container-fluid bg-primary py-5 bg-prd12 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Pomegranate </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Pomegranate </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Pomegranate</h2>
        <h5 className='text-muted'> Egyptian pomegranates are renowned for their rich red color and juicy, flavorful 
seeds. They come in several varieties, including Wonderful, Manfaluti, Baladi. 
Typically harvested from September to December, these pomegranates are available 
in various sizes. They are prized for their sweet-tart taste and are commonly enjoyed 
fresh, in cooking, or as juice. The fruit is usually packaged in cartons or plastic trays, 
with options for different net and gross weights.

        </h5>
      </div>

      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>types:</h5>
        <h5 className=' mt-3'>wonderful
        </h5>
        <h5 className=' mt-3'> manfaluti
        </h5>
        <h5 className=' mt-3'>   baladi</h5>
        <h5 className=' mt-3'>    early 116</h5>
      </div>
      <hr />
      <hr />
          <h2 className='text-primary my-3'>Season:</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>from september to december
          </h5>
        </li>


      </ul>
      <hr />

      <h2 className='text-primary my-3'>Packing</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>
            4.50نg net weight carton, 5 kg gross weight carton
          Or 4.50 kg net weight plastic tray, 5 kg gross weight plastic tray
          </h5>
        </li>

      </ul>
      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Size:</h5>
        <h5 className=' mt-3'> ( 6, 7, 8, 9, 10, 11, 12, 13, 14)</h5>
      </div>
      <hr />

      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
